import React from 'react'
import { Grid, Card, CardContent, Typography, Box, Avatar } from '@mui/material'
import { 
  People as PeopleIcon,
  PersonAdd as PersonAddIcon,
  EventAvailable as EventIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
} from '@mui/icons-material'

interface MetricCardProps {
  title: string
  value: string | number
  change?: number
  changeLabel?: string
  icon: React.ReactNode
  color: string
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, change, changeLabel, icon, color }) => {
  const isPositive = change && change >= 0

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography color="textSecondary" gutterBottom variant="body2">
              {title}
            </Typography>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold', mb: 1 }}>
              {value}
            </Typography>
            {change !== undefined && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {isPositive ? (
                  <TrendingUpIcon sx={{ color: 'success.main', mr: 0.5, fontSize: 16 }} />
                ) : (
                  <TrendingDownIcon sx={{ color: 'error.main', mr: 0.5, fontSize: 16 }} />
                )}
                <Typography
                  variant="body2"
                  sx={{
                    color: isPositive ? 'success.main' : 'error.main',
                    fontWeight: 'bold',
                  }}
                >
                  {Math.abs(change)}%
                </Typography>
                {changeLabel && (
                  <Typography variant="body2" sx={{ ml: 0.5, color: 'text.secondary' }}>
                    {changeLabel}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
          <Avatar
            sx={{
              bgcolor: color,
              width: 56,
              height: 56,
            }}
          >
            {icon}
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  )
}

const MetricsCards: React.FC = () => {
  // Mock data - in a real app, this would come from an API
  const metrics = [
    {
      title: 'Total Leads',
      value: 247,
      change: 12,
      changeLabel: 'vs last month',
      icon: <PeopleIcon />,
      color: '#3b82f6',
    },
    {
      title: 'Qualified Leads',
      value: 156,
      changeLabel: '(63%)',
      icon: <PersonAddIcon />,
      color: '#10b981',
    },
    {
      title: 'Bookings',
      value: 67,
      changeLabel: '(27%)',
      icon: <EventIcon />,
      color: '#8b5cf6',
    },
    {
      title: 'Revenue',
      value: '$18,420',
      change: 8,
      changeLabel: 'vs last month',
      icon: <MoneyIcon />,
      color: '#f59e0b',
    },
  ]

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      {metrics.map((metric, index) => (
        <Grid item xs={12} sm={6} lg={3} key={index}>
          <MetricCard {...metric} />
        </Grid>
      ))}
    </Grid>
  )
}

export default MetricsCards
